var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQWqRGhFp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4924 2.99706L18.4992 21.0004C18.4996 21.8267 17.8304 22.4941 16.9998 22.4943L3.00053 22.4993C2.1719 22.4996 1.5 21.8279 1.5 20.9993V3C1.5 2.17157 2.17157 1.5 3 1.5H16.9924C17.8214 1.5 18.4921 2.16962 18.4924 2.99706Z",
    stroke: "#25BBFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69873 8.33331H14.7758",
    stroke: "#25BBFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69873 5.46875H14.7758",
    stroke: "#25BBFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69873 11.1111H11.4168",
    stroke: "#25BBFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3102 16.3836L11.7168 17.7281L13.2172 14.5039L20.6668 7.81946L22.7599 9.69918L15.3102 16.3836Z",
    fill: "#262626"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1562 7.3108C20.8804 7.06315 20.4536 7.06306 20.1777 7.31059L12.7281 13.995C12.6576 14.0582 12.6011 14.1344 12.5616 14.2191L11.0613 17.4434C10.9417 17.7003 10.9947 18.0016 11.1953 18.206C11.3959 18.4104 11.7045 18.4774 11.9764 18.3757L15.5698 17.0311C15.6547 16.9994 15.7326 16.9523 15.7993 16.8924L23.249 10.208C23.3954 10.0767 23.4786 9.89236 23.4786 9.69932C23.4787 9.50629 23.3956 9.32194 23.2492 9.19052L21.1562 7.3108ZM13.2755 16.0721L13.7113 15.1356L14.5331 15.9296L13.532 16.3042L13.2755 16.0721ZM15.6964 15.0894L14.697 14.1238L18.8602 10.3882L19.8596 11.3538L15.6964 15.0894ZM20.9137 10.408L21.7039 9.69894L20.6666 8.76736L19.9143 9.4424L20.9137 10.408Z",
    fill: "#25BBFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQWqRGhFp);
export default __webpack_public_path__ + "static/media/qWqRGhFP.0c3be28fc5d62d328a665c44e15eae46.svg";
export { ForwardRef as ReactComponent };